const { auth0Config } = window["runtimeConfig"];

export default {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  audience: auth0Config.audience,
  scopes: auth0Config.scopes,
  connection: auth0Config.connection,
  federatedLogout: auth0Config.federatedLogout,
};
